(() => {
  const ROOT_SELECTOR = '[data-ob-collection-search]';

  const go = (root) => {
    const input = root?.querySelector('[data-ob-collection-search-input]');
    if (!input) return;
    const query = input.value.trim();
    if (!query) {
      input.focus();
      return;
    }
    const base = root.dataset.searchUrl || '/search';
    const params = new URLSearchParams({ q: query, type: 'product' });
    params.set('options[prefix]', 'last');
    window.location.assign(`${base}?${params.toString()}`);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ob-collection-search-button]');
    if (!button) return;
    const root = button.closest(ROOT_SELECTOR);
    if (!root) return;
    event.preventDefault();
    go(root);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest?.('[data-ob-collection-search-input]');
    if (!input) return;
    const root = input.closest(ROOT_SELECTOR);
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    go(root);
  });


  // Shopify occasionally applies a vendor URL filter (notably EPOS) without
  // returning it as an active facet value. Keep the sidebar state truthful to
  // the URL so every manufacturer link behaves consistently.
  const syncVendorFilterState = () => {
    const url = new URL(window.location.href);
    const vendor = url.searchParams.get('filter.p.vendor');
    const sidebars = document.querySelectorAll('#main-collection-filters, #main-search-filters');

    sidebars.forEach((sidebar) => {
      const injectedVendorPill = sidebar.querySelector('[data-ob-injected-vendor]');
      if (!vendor) {
        injectedVendorPill?.remove();
        return;
      }

      // If Shopify already rendered the active vendor pill (e.g. Jabra), leave it alone.
      const existingVendorPill = Array.from(sidebar.querySelectorAll('.active-facets__button:not([data-ob-injected-vendor] .active-facets__button)')).find((link) => {
        const text = (link.textContent || '').trim().toLowerCase();
        return text.startsWith('brand:') || text.startsWith('vendor:') || text.includes(`brand: ${vendor.toLowerCase()}`);
      });

      // Reflect the URL state in the vendor checkbox as well.
      sidebar.querySelectorAll('input[name="filter.p.vendor"]').forEach((input) => {
        if ((input.value || '').toLowerCase() === vendor.toLowerCase()) {
          input.checked = true;
          input.closest('label')?.classList.add('active');
        }
      });

      if (existingVendorPill) {
        injectedVendorPill?.remove();
        return;
      }

      // Already normalised for this URL; avoid creating DOM churn inside the observer.
      if (injectedVendorPill?.dataset.obVendor?.toLowerCase() === vendor.toLowerCase()) return;
      injectedVendorPill?.remove();

      const activeFacets = sidebar.querySelector('.active-facets-desktop');
      if (!activeFacets) return;

      const removeUrl = new URL(window.location.href);
      removeUrl.searchParams.delete('filter.p.vendor');
      removeUrl.searchParams.delete('page');

      const facetRemove = document.createElement('facet-remove');
      facetRemove.dataset.obInjectedVendor = 'true';
      facetRemove.dataset.obVendor = vendor;

      const link = document.createElement('a');
      link.href = `${removeUrl.pathname}${removeUrl.search}${removeUrl.hash}`;
      link.className = 'active-facets__button active-facets__button--light';

      const inner = document.createElement('span');
      inner.className = 'active-facets__button-inner button button--tertiary';
      inner.append(document.createTextNode(`Brand: ${vendor} `));

      const close = document.createElement('span');
      close.className = 'ob-active-brand-close';
      close.setAttribute('aria-hidden', 'true');
      close.textContent = '×';
      inner.append(close);

      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = 'Clear filter';
      inner.append(hidden);

      link.append(inner);
      facetRemove.append(link);
      activeFacets.append(facetRemove);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVendorFilterState);
  } else {
    syncVendorFilterState();
  }

  const vendorFacetObserver = new MutationObserver(() => syncVendorFilterState());
  vendorFacetObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
